import React from 'react';
import logo from '../assets/SDP-white.png';
import { useSdpMode } from '../context/SdpModeContext';
import { useSessionSettings } from '../context/SessionSettingsContext';

const Header = ({ onMenuClick, userRole, isSidebarOpen, autopilotEnabled, onAutopilotToggle }) => {
  const { sdpMode } = useSdpMode();
  const { goalAmount, forecastAmount } = useSessionSettings();

  const getModeLabel = (mode) => {
    switch (mode) {
      case 'off':
        return 'OFF';
      case 'recommendation':
        return 'Recommendation';
      case 'simulation':
        return 'Simulation';
      case 'autopilot':
        return 'Full Self-Driving';
      default:
        return 'OFF';
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-btn" onClick={onMenuClick} aria-label="Toggle menu">
                  <i className={`fas ${isSidebarOpen ? 'fa-bars' : 'fa-bars'}`}></i>
        </button>
            {/*  <img src={sikkaIcon} alt="Sikka.ai" className="logo" />*/}
        <img src={logo} alt="SDP" className="logo" />
      
      </div>
      <div className="header-right">
              <div className="sdp-mode-header-display">
          <span className="sdp-mode-header-label">SELF-DRIVING PRACTICE MODE:</span>
          <span className="sdp-mode-header-badge">{getModeLabel(sdpMode)}</span>
              </div>
              {/*{userRole === 'dso' ? "":*/}
              {/*    <div className="header-info">*/}
              {/*        <span className="subtext">Cumulative Production Increase Due to Self-Driving Practice®</span>*/}
              {/*    </div>*/}
              {/*}*/}
              <div className="header-info header-info-goal">
                  <span className="adminRolecss roundedHead">
                      Goal: ${(goalAmount / 1000).toFixed(0)}K <i className="fas fa-circle" style={{fontSize: "8px", paddingBottom: "5px"}} />   
                      Forecast: ${(forecastAmount / 1000).toFixed(0)}K
                  </span>
              </div> 

             <div className="header-info header-info-admin">
                  <span className="adminRolecss roundedHead">{userRole === "dso" ? "DSO" : userRole === "vet" ? "Visionary Vet" : "Visionary Dental"}                  
                      <i className="fas fa-circle" style={{ fontSize: "8px", margin: "5px" }} />   Admin</span> 
              
              </div> 
                  {/*<div className="header-info">*/}
                  {/*<span className="amount roundedHead">$168,041</span>*/}
                  {/*</div>*/}
             
        {/*<button className="notification-btn">*/}
        {/*  <i className="fas fa-bell"></i>*/}
        {/*</button>*/}
      </div>
    </header>
  );
};

export default Header;
